import React from 'react';
import {Table} from "antd";

const PositionFixedFeeTab = ({candidate, position}) => {
    const talentOpp = TB.first(candidate?.job_candidate.talent_opps);

    return (
        <div className="proposal-padding">

            {candidate.confirmedStartedAt() && (
                <div className="confirmed-availability-note">
                    <p>
                        The candidate has updated {position.fixedFeePricingStrategyIsFullBreakdown() ? 'their rate': 'their estimated cost'} and confirmed deliverables
                    </p>
                    <p>
                        <small>
                            <b>
                                Last Updated: {TB.moment(candidate.job_candidate.talent_proposal_updated_at).fromNow()}
                            </b>
                        </small>
                    </p>
                </div>
            )}
            <h3 className="proposal-tab-header mt-2">
                Estimated Fee:
            </h3>
            <p className="proposal-input">
                {!candidate.hasSubmittedProposal() ?
                    'Proposal Cost Pending' :
                    (
                        <span>
                            {candidate.proposedPlatformCost()}
                        </span>
                    )
                }
            </p>

            <hr/>

            <Table
                rowKey="id"
                dataSource={TB.orderBy(talentOpp.position_deliverables || [], del => del.target_delivery_at ? TB.moment(del.target_delivery_at).valueOf() : 0, 'asc')}
                bordered
                size="middle"
                pagination={false}>
                <Table.Column
                    title={(<p className="whitespace-nowrap text-sm">Deliverables</p>)}
                    dataIndex="name"
                    fixed="left"
                    width={200}
                    render={name => (
                        <p className="text-xs">{name}</p>
                    )}
                />

                <Table.Column
                    title={(<p className="whitespace-nowrap text-sm">Target Delivery Date</p>)}
                    dataIndex="target_delivery_at"
                    width={50}
                    render={(target_delivery_at, deliverable) => (
                        <p className={TB.mapClass("text-xs", {
                            "line-through opacity-60 text-danger": false//!deliverable.is_active
                        })}>
                            {target_delivery_at ? TB.moment(target_delivery_at).format('ll') : (
                                <i>No Date Provided...</i>
                            )}
                        </p>
                    )}
                />

                {!position.fixedFeePricingStrategyIsTotalPayout() && !!TB.find(talentOpp.position_deliverables, del => !!del.total_hours) && (
                    <Table.Column
                        title={(<p className="whitespace-nowrap text-sm">Estimated Hours</p>)}
                        dataIndex="total_hours"
                        width={40}
                        render={(total_hours, deliverable) => (
                            <p className={TB.mapClass("text-xs", {
                                "line-through opacity-60 text-danger": false//!deliverable.is_active
                            })}>
                                {parseInt(total_hours) > 0 ? `${total_hours} hours` : 'Not provided...'}
                            </p>
                        )}
                    />
                )}

                {!position.fixedFeePricingStrategyIsTotalPayout() && (
                    <Table.Column
                        title={(<p className="whitespace-nowrap text-sm">Est Cost</p>)}
                        dataIndex="estimated_cost"
                        width={60}
                        render={(_, deliverable) => (
                            <p className={TB.mapClass("text-xs", {
                                "line-through opacity-60 text-danger": false//!deliverable.is_active
                            })}>
                                {!TB.isNaN(parseFloat(deliverable.payout_amount)) ? TB.formatCurrency(parseFloat(deliverable.payout_amount)) : '-'}
                            </p>
                        )}
                    />
                )}

            </Table>
        </div>
    );
};

export default PositionFixedFeeTab;